import React from 'react';
import ErrorBoundaries from '../../../components/ErrorBoundaries';
import EinstellungenSeitenKopf from '../components';
import AllBrachofficeTable from './AllBranchofficeTable';

function BranchofficePage() {
  return (
    <>
      <EinstellungenSeitenKopf title="Marken" />
      <ErrorBoundaries>
        <AllBrachofficeTable />
      </ErrorBoundaries>
    </>
  );
}

export default BranchofficePage;
